export default __webpack_public_path__ + "static/media/img9.f001ce79.svg";